import {request} from "../base/HTTP";
import HttpMethod from "../constants/HttpMethod";

export async function contactUs(data) {
    return await request('/api/users/contact_us', data, HttpMethod.POST);
}